import { ReactElement, useEffect } from 'react';
import { TabBarPropsType } from 'rmc-tabs';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { Badge, Container, Tab, Wrapper } from './style';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

interface Props extends TabBarPropsType {
  fixedTop?: number;
  bordered?: boolean;
  fullwidth?: boolean;
  size?: 'default' | 'middle' | 'large';
  editBet?: boolean;
  allLsBetsCount?: number;
  fromMenu?: boolean;
}

export const CustomTabBar = (props: Props): ReactElement => {
  const fullwidth = props.fullwidth == undefined ? true : props.fullwidth;

  useEffect(() => {
    if (props.editBet) {
      props.goToTab(0);
    }
  }, [props.editBet, props.allLsBetsCount]);

  return (
    <Container
      fixedTop={props.fixedTop}
      size={props.size || 'default'}
      fromMenu={props.fromMenu}
    >
      <Wrapper bordered={props.bordered || false}>
        {props.tabs.map((tab, index) => (
          <Tab
            onClick={() => props.goToTab(index)}
            active={props.activeTab === index}
            fullwidth={fullwidth}
            key={index}
            tabsCount={props.tabs.length}
            fromMenu={props.fromMenu}
            className="customTab__tab-container"
          >
            {tab.title}
            {tab.badge !== undefined && (
              <Badge className="customTab__badge">{tab.badge}</Badge>
            )}
          </Tab>
        ))}
      </Wrapper>
    </Container>
  );
};
